<!--
 * @Description: 维修换机确认弹框
 * @Author: Claude
 * @Date: 2026-04-29
-->
<template>
  <el-dialog
    v-dialogDrag
    title="维修换机确认"
    :visible.sync="visible"
    width="75%"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-loading="loading"
    :element-loading-background="loadingBackground"
    custom-class="repair-replace-dialog"
    @open="handleOpen"
  >
    <div class="dialog-content">
      <!-- 基础信息 -->
      <div class="section">
        <div class="section-title">
          <span class="line"></span>
          基础信息
        </div>
        <el-form :inline="true" class="base-info-form">
          <el-row>
            <el-col :span="8">
              <el-form-item label="客户名称：">{{ baseInfo.corpName }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请人：">{{ baseInfo.applyName }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="修改单数：">{{ baseInfo.itemCount }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="工单ID：">{{ workOrderIds }}</el-form-item>
            </el-col>
            <!--<el-col :span="16">
              <el-form-item label="故障原因及处理措施：">{{ faultReason }}</el-form-item>
            </el-col>-->
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="修改备注：" class="full-width">
                <el-input
                  v-model="modifyRemark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入修改备注"
                  maxlength="100"
                  show-word-limit
                  style="width: 600px"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 维修换机申请 -->
      <div class="section">
        <div class="section-title">
          <span class="line"></span>
          维修换机申请
        </div>
        <el-table
          :data="applyList"
          highlight-current-row
          border
          max-height="400px"
          style="width: 100%"
        >
          <el-table-column
                  prop="itemId"
                  label="工单ID"
                  min-width="70"
                  align="center"
                  header-align="center"
          />
          <el-table-column
            prop="oldMaterialName"
            label="原物料名称"
            min-width="120"
            align="center"
            header-align="center"
          />
          <el-table-column
            prop="oldMaterialNo"
            label="原物料编码"
            min-width="100"
            align="center"
            header-align="center"
          />
          <el-table-column
            prop="oldEquipCode"
            label="原设备号"
            min-width="100"
            align="center"
            header-align="center"
          />
          <el-table-column
            prop="newMaterialName"
            label="新物料名称"
            min-width="120"
            align="center"
            header-align="center"
          />
          <el-table-column
            prop="newMaterialNo"
            label="新物料编码"
            min-width="100"
            align="center"
            header-align="center"
          />

          <el-table-column
            prop="applyReason"
            label="申请原因"
            min-width="150"
            align="center"
            header-align="center"
          />
          <el-table-column
            prop="applyTime"
            label="申请时间"
            min-width="150"
            align="center"
            header-align="center"
          />
          <el-table-column
            label="现场凭证"
            min-width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.fileUrlList && row.fileUrlList.length > 0" class="image-list">
                <el-image
                  v-for="(url, index) in row.fileUrlList"
                  :key="index"
                  :src="url"
                  :preview-src-list="row.fileUrlList"
                  class="scene-image"
                  fit="cover"
                />
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="换机确认"
            min-width="120"
            align="center"
            fixed="right"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <el-select v-model="row.replaceConfirm" placeholder="请选择">
                <el-option label="同意换机" :value="1" />
                <el-option label="拒绝换机" :value="2" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="拒绝原因"
            min-width="150"
            align="center"
            header-align="center"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <el-input
                v-if="row.replaceConfirm === 2"
                v-model="row.rejectReason"
                placeholder="请输入拒绝原因"
                maxlength="100"
                size="small"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="dialog-footer" slot="footer">
      <el-button class="cancel" @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { printError } from "@/utils/util";
import { batchQueryReplaceApply, batchAuditReplaceApply } from "@/api";

export default {
  name: "RepairReplaceConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    itemIdList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      loadingBackground: "rgba(255,255,255,0.5)",
      // 基础信息
      baseInfo: {
        corpName: "",
        applyName: "",
        itemCount: 0
      },
      workOrderIds: "",
      faultReason: "////",
      modifyRemark: "",
      // 申请列表
      applyList: []
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchData();
      }
    }
  },
  methods: {
    handleOpen() {
      // 重置数据
      this.modifyRemark = "";
      this.applyList = [];
      this.baseInfo = {
        corpName: "",
        applyName: "",
        itemCount: 0
      };
      this.workOrderIds = "";
      this.faultReason = "////";
    },
    // 获取数据
    async fetchData() {
      if (!this.itemIdList || this.itemIdList.length === 0) {
        this.$message.warning("工单ID列表为空");
        return;
      }
      try {
        this.loading = true;
        const res = await batchQueryReplaceApply({
          itemIdList: this.itemIdList
        });
        if (res.code === "OK" && res.data) {
          const { applyList, applyName, corpName, itemCount } = res.data;
          this.baseInfo = {
            corpName: corpName || "",
            applyName: applyName || "",
            itemCount: itemCount || 0
          };
          this.workOrderIds = this.itemIdList.join(",");
          // 处理申请列表数据
          this.applyList = (applyList || []).map(item => ({
            ...item,
            replaceConfirm: 1, // 默认同意换机
            rejectReason: ""   // 拒绝原因初始为空
          }));
        } else {
          this.$message.warning(res.msg || "获取数据失败");
        }
      } catch (error) {
        printError(error);
        this.$message.error("获取维修换机申请数据失败");
      } finally {
        this.loading = false;
      }
    },
    // 关闭弹框
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    // 确定提交
    async handleConfirm() {
      // 校验拒绝原因
      const rejectItems = this.applyList.filter(
        item => item.replaceConfirm === 2 && (!item.rejectReason || item.rejectReason.trim() === "")
      );
      if (rejectItems.length > 0) {
        this.$message.warning("拒绝换机时请输入拒绝原因");
        return;
      }

      // 构造审核数据
      const auditList = this.applyList.map(item => ({
        replaceRecordId: item.replaceRecordId,
        auditResult: item.replaceConfirm === 2 ? item.rejectReason : "",
        applyStatus: item.replaceConfirm === 2 ? 3 : 2 // 2-审核通过, 3-申请驳回
      }));

      const submitData = {
        remark: this.modifyRemark,
        auditList: auditList
      };

      try {
        this.submitLoading = true;
        const res = await batchAuditReplaceApply(submitData);
        if (res.code === "OK") {
          this.$message.success("提交成功");
          this.$emit("success");
          this.handleClose();
        } else {
          this.$message.warning(res.msg || "提交失败");
        }
      } catch (error) {
        printError(error);
        this.$message.error("提交失败");
      } finally {
        this.submitLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.repair-replace-dialog {
  /deep/.el-dialog__body {
    padding: 10px 20px 20px;
  }
}

.dialog-content {
  padding: 0 20px;

  .section {
    margin-bottom: 20px;
  }

  .section-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;

    .line {
      display: inline-block;
      width: 4px;
      height: 16px;
      background-color: #409eff;
      margin-right: 8px;
    }
  }

  .base-info-form {
    .el-form-item {
      margin-bottom: 10px;
    }

    .el-form-item__label {
      color: #666;
    }

    .el-form-item__content {
      color: #333;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;

  .cancel {
    margin-right: 10px;
  }
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;

  .scene-image {
    width: 50px;
    height: 50px;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
